import { z } from 'zod';

export const getEvaluationSessionDetailsSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export type GetEvaluationSessionDetailsPayload = z.infer<typeof getEvaluationSessionDetailsSchema>;
